import cls from "./customInnerPage.module.scss";
import React, {Dispatch, FC, ReactNode, SetStateAction} from "react";
import InputNumber from "../../shared/InputNumber";

interface ICustomSideBar {
    ProductAddToCart_INTL: string;
    actionClassName: string;
    handleCardClick: (quantity: number) => Promise<void>;
    isButtonDisabled: boolean;
    wishListButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    wishIconClicked: ReactNode;
    minimalQty: number;
    maximalQty: number;
    inpValQuantity: number;
    setQuantity: Dispatch<SetStateAction<number>>
}

const CustomSideBar: FC<ICustomSideBar> = (
    {
       ProductAddToCart_INTL,
       actionClassName,
       handleCardClick,
       isButtonDisabled,
       wishListButtonClick,
       wishIconClicked,
       minimalQty,
       maximalQty,
       inpValQuantity,
       setQuantity
   }
) => {
    return (
        <div className={cls["product__sidebar"]}>
            <form className={cls["product__options"]}>
                <div className={`form-group ${cls["product__option"]}`}>
                    <div className={cls["product__actions"]}>
                        <div className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>
                            <InputNumber
                                id="product-quantity"
                                aria-label="Quantity"
                                className={cls["product__quantity"]}
                                size="lg"
                                min={minimalQty}
                                max={maximalQty}
                                value={inpValQuantity}
                                onChange={(quantity: number) => setQuantity(quantity)}
                            />
                        </div>
                        <div className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}`}>
                            <div className={`
                                    ${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}
                                    ${actionClassName}
                                `}
                            >
                                <button
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        await handleCardClick(inpValQuantity)
                                    }}
                                    disabled={isButtonDisabled}
                                    className={`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg`}
                                >
                                    {ProductAddToCart_INTL}
                                </button>
                            </div>
                        </div>
                        <div
                            className={`${cls["product__actions-item"]} ${cls["product__actions-item--wishlist"]} ${cls["liked-button-wrapper"]}`}>
                            <span>
                                <button
                                    aria-label="Wish list"
                                    title="Wishlist"
                                    onClick={wishListButtonClick}
                                    className="btn-light btn-svg-icon btn-svg-icon--fake-svg"
                                >
                                    <div className={cls["wishlist-icon-wrapper"]}>
                                        {wishIconClicked}
                                    </div>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default CustomSideBar;
